define([
    "./hereMapsModule"
], function (hereMapsModule) {
    "use strict";

    return hereMapsModule.factory("hereMapsLoadingService", [
        function () {
            var isLoading = false;

            return {
                start: start,
                stop: stop,
                isLoadingHereMaps: isLoadingHereMaps
            };

            function start() {
                isLoading = true;
            }

            function stop() {
                isLoading = false;
            }

            function isLoadingHereMaps() {
                return isLoading;
            }
        }

    ]);
});